module.exports = __webpack_public_path__ + "fonts/texgyrepagella-italic.85a2b761.otf";